import { AxiosError } from 'axios';
import { useCallback, useState } from 'react';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../models/https';
import { ITableResponse } from '../models/table.model';
import useHttps from './useHttps';

const useTable = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const [endPage, setEndPage] = useState(1);
  const [tableData, setTableData] = useState<any[]>([]);

  const onTableLoadError = useCallback((_: AxiosError<ErrorHttpResponse>) => {
    setTableData([]);
    setEndPage(0);
  }, []);

  const downloadTableData = useCallback(
    ({ data }: SuccessHttpResponse<ITableResponse>) => {
      const resolvedTotalPages =
        typeof data?.totalPages === 'number' ? data.totalPages : 1;

      if (Array.isArray(data?.records)) {
        setTableData(data.records);
        setEndPage(resolvedTotalPages);
      } else if (Array.isArray(data)) {
        setTableData(data);
        setEndPage(1);
      } else {
        setTableData([]);
        setEndPage(0);
      }
    },
    [],
  );

  const fetchTableData = useCallback((link: string) => {
    if (!link) {
      setTableData([]);
      setEndPage(0);
      return;
    }

    const url: HttpConfig = {
      url: link,
      method: 'get',
    };

    request(url, downloadTableData, setLoading, onTableLoadError);
  }, [downloadTableData, onTableLoadError, request]);

  return { fetchTableData, loading, setLoading, tableData, endPage };
};

export default useTable;
